/* Quick-add + cross-sell + sticky subnav for Shop Extras */
(function () {
  const root = document.querySelector('.if-section');
  if (!root) return;

  // Mark body once the user has scrolled — unlocks the active-pill fill
  const markScrolled = () => document.body.classList.add('has-scrolled');
  window.addEventListener('scroll', markScrolled, { passive: true, once: true });

  root.querySelectorAll('[data-if-qty]').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-if-qty-decrement]')?.addEventListener('click', () => {
      const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    qty.querySelector('[data-if-qty-increment]')?.addEventListener('click', () => {
      const v = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
      input.value = v;
    });
  });

  root.querySelectorAll('form[data-if-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const card = form.closest('.if-card');
      const btn = form.querySelector('button[type="submit"]');
      if (btn?.disabled) return;
      card?.classList.add('is-loading');
      btn?.setAttribute('aria-busy', 'true');
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Could not add to cart');
        }
        await res.json();
        card?.classList.remove('is-loading');
        card?.classList.add('is-added');
        setTimeout(() => card?.classList.remove('is-added'), 1600);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        openCrosssell();
      } catch (err) {
        console.error('[shop-extras] add to cart failed', err);
        card?.classList.remove('is-loading');
        alert(err.message || 'Could not add to cart');
      } finally {
        btn?.removeAttribute('aria-busy');
      }
    });
  });

  const drawer = root.querySelector('.if-crosssell');
  function openCrosssell() {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.setAttribute('data-open', 'true'));
    clearTimeout(openCrosssell._t);
    openCrosssell._t = setTimeout(closeCrosssell, 7000);
  }
  function closeCrosssell() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    setTimeout(() => { drawer.hidden = true; }, 280);
  }
  drawer?.querySelector('[data-if-close]')?.addEventListener('click', closeCrosssell);

  // Sticky subnav active state + stuck detection
  const nav = root.querySelector('.if-subnav');
  if (nav) {
    const links = Array.from(nav.querySelectorAll('.if-subnav__link'));
    const targets = links
      .map((link) => {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return null;
        const el = document.getElementById(href.substring(1));
        return el ? { el, link } : null;
      })
      .filter(Boolean);

    // If a user clicks a link, treat that as an intentional selection
    links.forEach((link) => {
      link.addEventListener('click', () => {
        markScrolled();
      });
    });

    if (targets.length) {
      const activeObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const active = targets.find((t) => t.el === entry.target);
              if (active) {
                links.forEach((l) => l.classList.remove('is-active'));
                active.link.classList.add('is-active');
              }
            }
          });
        },
        { rootMargin: '-30% 0px -60% 0px', threshold: 0 }
      );
      targets.forEach((t) => activeObserver.observe(t.el));
    }

    // Stuck-state detection via sentinel that scrolls out of view when nav pins
    const sentinel = root.querySelector('.if-subnav-sentinel');
    if (sentinel) {
      const stuckObserver = new IntersectionObserver(
        ([entry]) => {
          nav.classList.toggle('is-stuck', !entry.isIntersecting);
        },
        { threshold: 0 }
      );
      stuckObserver.observe(sentinel);
    }
  }
})();
